import React from 'react'
import {
  Route,
  Routes
} from "react-router-dom"; 
import Navbar from './components/navbar/Navbar'
import Aboutus from './pages/Aboutus'
import Ecommerce from './pages/Ecommerce'
import Home from './pages/Home'
import Intership from './pages/Intership'
import Mobileappdevelopment from './pages/Mobileappdevelopment'
import Ourteam from './pages/Ourteam'
import Productanddesign from './pages/Productanddesign'
import Softwaredevelopment from './pages/Softwaredevelopment'
import Webdevelopment from './pages/Webdevelopment'
import Wordpress from "./pages/Wordpress"
import Jobs from './pages/Jobs';
import Footer from './components/footer/Footer';
import Scrolltotop from './components/srolltotop/Scrolltotop';
import Contact from './pages/Contact';
export default function App() {
  return (
    <div>
      <Navbar/>
      <Routes>
        <Route exact path='/' element={<Home />}/>
        <Route  path='/aboutus' element={<Aboutus />}/>
        <Route  path='/services/ecommerce' element={<Ecommerce />} />
        <Route  path='/career/intership' element={<Intership />}/>
        <Route  path='/services/mobileappdevelopment' element={<Mobileappdevelopment />}/>
        <Route  path='/ourteam' element={<Ourteam />}/>
        <Route  path='/services/productanddesign' element={<Productanddesign />}/>
        <Route  path='/services/softwaredevelopment' element={<Softwaredevelopment />} />
        <Route  path='/services/webdevelopment' element={<Webdevelopment />} />
        <Route  path='/services/wordpress' element={<Wordpress />} />
        <Route  path='/carrer/jobs' element={<Jobs />} />
        <Route path='/contact-us' element={<Contact/>}/>
      </Routes>
      <Footer/>
      <Scrolltotop/>
    </div>
  )
}
